var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplianceDaysIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.196289,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#722ED1",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2498 15.8633C19.6498 15.8633 15.9165 19.5966 15.9165 24.1966C15.9165 28.7966 19.6498 32.5299 24.2498 32.5299C28.8498 32.5299 32.5832 28.7966 32.5832 24.1966C32.5832 19.5966 28.8498 15.8633 24.2498 15.8633ZM24.2498 30.8633C20.5748 30.8633 17.5832 27.8716 17.5832 24.1966C17.5832 20.5216 20.5748 17.5299 24.2498 17.5299C27.9248 17.5299 30.9165 20.5216 30.9165 24.1966C30.9165 27.8716 27.9248 30.8633 24.2498 30.8633ZM28.0748 20.5133L22.5832 26.0049L20.4248 23.8549L19.2498 25.0299L22.5832 28.3633L29.2498 21.6966L28.0748 20.5133Z",
    fill: "#722ED1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceDaysIcon);
export default __webpack_public_path__ + "static/media/complianceDaysIcon.e972895368f7492ff4f4323b1068361f.svg";
export { ForwardRef as ReactComponent };